<template>
    <div class="base-quick">
        <header class="header">
            <div class="goback" @click="onBack">
                <img class="back" src="~images/back.png" />
                <div class="title">焕游游戏快捷登录</div>
            </div>
        </header>
        <div class="content-logo">
            <img class="logo" src="~images/logo_max.png" />
            <img class="switch-max" src="~images/switch_max.png" />
            <img class="yx-logo" :src="yxLogo" />
        </div>
        <div class="content-user">
            <div class="app-logo">APP当前登录</div>
            <div class="acc">{{account.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')}}</div>
            <div class="name">{{accountPwd.name}}</div>
        </div>
        <div class="btn-box">
            <div class="login" @click="onLogin">登录当前账号</div>
            <div class="switch" @click="onOpen">
                <img class="switch-min" src="~images/switch_min.png" />
                <div>切换其它账号</div>
            </div>
        </div>
        <transition name="component-fade" mode="out-in">
            <TheTips :msg='msg' v-if="msg" />
        </transition>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        // 进入路由之前
        beforeRouteEnter (to, from, next) {
            next(vm => {
                // beforeRouteEnter不能通过this访问组件实例，但是可以通过 vm 访问组件实例
                if (vm.config.system == 1) {
                    // 竖屏
                    window.Android.setOriPortrait()
                }
            })
        },
        name: 'BaseQuick',
        components: {
            TheTips
        },
        data () {
            return {
                msg: null,
                accountPwd: {},
                account: '',
                loginData: {},
                yxLogo: ''
            }
        },
        methods: {
            onBack () {
                this.$router.back()
                if (this.config.system == 1) {
                    // 恢复正常屏幕
                    window.Android.setOriBehind()
                }
            },
            onLogin () {
                if (this.accountPwd.account.replace(/\s*/g, "")) {
                    let reg = /^1[0-9]{10}$/
                    let type = 1 //1.账号、密码登录 2.手机号、密码登录
                    let options = {
                        password: this.accountPwd.psw,
                        appid: this.loginData.appid, //应用ID
                        channel: this.loginData.channel, //渠道ID
                        system: this.loginData.system, //系统
                        machine_code: this.loginData.machine_code //设备号
                    };
                    if (reg.test(this.accountPwd.account)) {
                        options = {
                            mobile: this.accountPwd.account,
                            type: 2,
                            ...options
                        }
                    } else {
                        options = {
                            username: this.accountPwd.account,
                            type: 1,
                            ...options
                        }
                    }
                    options.sign = this.util.getSign(options, this.loginData.appkey);
                    this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=user&a=login', this.$qs.stringify(options)).then(res => {
                        if (res.data.status == 1) {
                            sessionStorage.setItem('userData', JSON.stringify(res.data))
                            this.msg = '登录成功'
                            setTimeout(() => {
                                this.msg = null
                                this.$router.push('/base-trumpet-select')
                                if (this.config.system == 1) {
                                    // 恢复正常屏幕
                                    window.Android.setOriBehind()
                                }
                            }, 1000)
                        } else {
                            this.msg = res.data.msg
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    }).
                    catch(o => {
                        this.msg = '请求失败'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    })
                }
            },
            // 打开app
            onOpen () {
                window.Android.openBox()
            },
            // 获取账号，密码
            updateAccount () {
                this.accountPwd = JSON.parse(window.Android.boxLogin())
                this.account = typeof this.accountPwd.account == 'number' ? JSON.stringify(this.accountPwd.account) : this.accountPwd.account
            },
            // 获取游戏logo
            getYxLogo () {
                let options = {
                    appid: this.loginData.appid, //应用ID
                }
                this.$axios.post('http://sdk.gameschain.pro/index.php?g=api&m=game&a=getGameInfo', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.yxLogo = res.data.data.logo
                    }
                })
            }
        },
        created () {
            this.loginData = JSON.parse(sessionStorage.getItem('loginData'))
            this.updateAccount()
            this.getYxLogo()
        },
        mounted () {
            // 暴露方法给安卓调用
            window.updateAccount = this.updateAccount
        }
    }
</script>

<style lang="scss" scoped>
    .base-quick {
        width: 100%;
        height: 100%;
        background: #fff;
        overflow-y: scroll;
        .header {
            width: 100%;
            height: 340px;
            background: #FF6B21;
            display: flex;
            align-items: center;
            .goback {
                height: 340px;
                display: flex;
                align-items: center;
            }
            .back {
                width: 130px;
                height: 130px;
                margin-left: 80px;
            }
            .title {
                font-size: 92px;
                margin-left: 35px;
            }
        }
        .content-logo {
            height: 250px;
            margin-top: 580px;
            display: flex;
            align-items: center;
            justify-content: center;
            .logo {
                width: 250px;
                height: 250px;
            }
            .switch-max {
                width: 75px;
                height: 75px;
                margin: 0 237px;
            }
            .yx-logo {
                width: 250px;
                height: 250px;
                border-radius: 52px;
                object-fit: cover;
            }
        }
        .content-user {
            display: flex;
            flex-direction: column;
            align-items: center;
            .app-logo {
                color: #999;
                font-size: 70px;
                margin-top: 200px;
            }
            .acc {
                color: #333;
                font-size: 105px;
                margin-top: 100px;
            }
            .name {
                color: #ccc;
                font-size: 60px;
                margin-top: 30px;
            }
        }
        .btn-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            .login {
                width: 1375px;
                height: 200px;
                font-size: 70px;
                border-radius: 100px;
                background: #FF6B21;
                margin-top: 280px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .switch {
                width: 1375px;
                height: 200px;
                color: #666;
                font-size: 70px;
                margin-top: 80px;
                display: flex;
                align-items: center;
                justify-content: center;
                .switch-min {
                    width: 50px;
                    height: 50px;
                    margin: 5px 20px 0 0;
                }
            }
        }
    }
</style>